import React, { useState } from 'react';
import { PlusIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { faqs } from '../data/faqs';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="py-20 px-4 bg-white scroll-mt-8" data-id="element-43" data-mp="1iy1cnu1gsp54">
      <div className="max-w-3xl mx-auto" data-id="element-44" data-mp="1nvbb1z6u0b53">
        <h2 className="text-3xl md:text-4xl font-black text-brand-text text-center mb-12" data-id="element-45" data-mp="2bkcaiwxosby8">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-46" data-mp="2fkw821m69hkw">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="bg-brand-panel rounded-2xl overflow-hidden border border-brand-creamDark/60" data-id="element-47" data-mp="21sgf5tmzizxp" data-mpi={i}>
                <h3 data-id="element-48" data-mp="2uigab0rooynd">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="w-full px-6 py-5 flex items-center justify-between gap-4 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-greenDark" data-id="element-49" data-mp="2uhx42hbebyp6">
                    <span className="font-bold text-brand-text" data-id="element-50" data-mp="20ocf57pb9sg4">{faq.q}</span>
                    <span className="shrink-0 text-brand-text" data-id="element-51" data-mp="2fdqle6xlbtra">
                      {isOpen ? <XIcon className="w-5 h-5" aria-hidden="true" data-id="element-52" data-mp="2aenppd3i2zvz" /> : <PlusIcon className="w-5 h-5" aria-hidden="true" data-id="element-53" data-mp="2oe6npd2lkuuk" />}
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-54" data-mp="2jd97h615eavp">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-55" data-mp="u0xkg30na5kr">
                      <p className="px-6 pb-5 text-brand-gray leading-relaxed" data-id="element-56" data-mp="2z0gib1vbmbpf">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}